import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
import styled, { css } from 'styled-components';
import { get } from '../../styles/constant';
const getDynamicBackground = _ref => {
  let {
    active,
    disabled
  } = _ref;
  let background;
  if (active) {
    background = get('colors.primary.blue.300');
  }
  if (disabled) {
    background = get('colors.functional.grey.50');
  }
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), background);
};
const getActiveColor = _ref2 => {
  let {
    active
  } = _ref2;
  const color = active ? get('colors.functional.grey.50') : get('colors.functional.grey.800');
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), color);
};
const getHoverColor = _ref3 => {
  let {
    staticItem,
    active,
    disabled
  } = _ref3;
  const background = staticItem || active || disabled ? '' : get('colors.functional.grey.200');
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), background);
};
const getDynamicPadding = _ref4 => {
  let {
    indented,
    staticItem
  } = _ref4;
  let padding = '8px 12px';
  if (indented) {
    padding = '8px 12px 8px 24px';
  }
  if (staticItem) {
    padding = '4px 12px 0';
  }
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), padding);
};
const Wrapper = styled.ul(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  border: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  padding: 0;\n  margin: 0;\n\n  hr {\n    border-top: 1px solid ", ";\n  }\n"])), props => props.noBorder ? 'none' : "1px solid ".concat(get('colors.functional.grey.400')(props)), get('space.4'), get('boxShadows.card.4'), get('colors.functional.grey.800'), get('fontSizes.16'), get('lineHeights.24'), get('colors.functional.grey.400'));
const Item = styled.li(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: ", ";\n  ", "\n  ", "\n  ", "\n  color: ", ";\n  &:hover {\n    ", "\n  }\n\n  &:first-of-type {\n    border-top-right-radius: ", ";\n    border-top-left-radius: ", ";\n  }\n  &:last-of-type {\n    border-bottom-right-radius: ", ";\n    border-bottom-left-radius: ", ";\n  }\n"])), props => props.disabled ? 'not-allowed' : 'pointer', props => getDynamicBackground(props), props => getDynamicPadding(props), props => getActiveColor(props), props => props.disabled ? get('colors.functional.grey.500') : get('colors.functional.grey.800'), props => getHoverColor(props), get('space.3'), get('space.3'), get('space.3'), get('space.3'));
const Graphics = styled.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  margin-right: ", ";\n"])), get('space.12'));
const Icon = styled.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-right: ", ";\n"])), get('space.13'));
const TrailingIcon = styled.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-left: ", ";\n"])), get('space.13'));
const Content = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 2;\n  color: ", ";\n  ", "\n\n  > p {\n    margin: 0;\n    color: ", ";\n  }\n\n  span {\n    font-size: ", ";\n    line-height: ", ";\n  }\n"])), props => props.disabled ? get('colors.functional.grey.500') : get('colors.functional.grey.800'), props => getActiveColor(props), props => props.disabled ? get('colors.functional.grey.500') : get('colors.functional.grey.800'), get('fontSizes.12'), get('lineHeights.16'));
const Components = {
  Content,
  Graphics,
  Icon,
  Item,
  TrailingIcon,
  Wrapper
};
export { Components };